import LockIcon from "@material-ui/icons/Lock";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { is_empty } from "features/Common/utils/common.utils";
import React from "react";
import moduleStyle from "../../WhitelabelLock.module.css";
import { WhitelabelModalDescription } from "../WhitelabelModalDescription";
import { WhitelabelLockCta } from "../WhitelabelLockCta/WhitelabelLockCta";
import style from "./WhitelabelLockComponent.module.css";

export const WhitelabelLockComponent = ({
  isAccessible,
  label = "Locked",
  hideLabel = false,
  hideIcon = false,
  modalTitle = "Pay & Unlock",
  modalDescription,
  className = "",
  iconStyle = { fill: "rgba(255, 170, 0, 1)", fontSize: 18 },
  showWhitelabelUnlockModal,
  toggleWhitelabelUnlockModal,
}) => {
  if (isAccessible) return null;

  const showChip = !hideIcon || !hideLabel;

  return (
    <>
      {showChip ? (
        <div
          id="WhitelabelLock"
          onClick={toggleWhitelabelUnlockModal}
          className={`${moduleStyle.chip} d-flex align-items-center fit_content pointer ${className}`}
        >
          {!hideIcon && <LockIcon style={{ ...iconStyle }} />}
          {!hideLabel && (
            <div className={`ml-2 ${moduleStyle.label}`}>{label}</div>
          )}
        </div>
      ) : null}

      {showWhitelabelUnlockModal && !is_empty(modalDescription) ? (
        <ExlyModal
          open={showWhitelabelUnlockModal}
          showSecondaryBtn={false}
          onClose={toggleWhitelabelUnlockModal}
          primaryBtnFullWidth
          customFooter={
            <div className={`${style.cta}`}>
              <WhitelabelLockCta
                onClose={(e) => toggleWhitelabelUnlockModal(e)}
              />
            </div>
          }
          modal_props={{
            modalPaperClassName: moduleStyle.desktopModalPaper,
          }}
          title={modalTitle}
        >
          <WhitelabelModalDescription modalDescription={modalDescription} />
        </ExlyModal>
      ) : null}
    </>
  );
};
